module.exports = __webpack_public_path__ + "static/img/0010-2未启用吉林市人民政府.4b71473.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0010-2未启用吉林市人民政府.jpg
// module id = tES/
// module chunks = 0